
  import { Component, Prop, Vue} from 'vue-property-decorator'
  import Card from './Card.vue'

  @Component({
    inheritAttrs: false,
    props: {
      ...(Card as any).props,
    },
  })
  export default class MaterialStatsCard extends Vue {
    @Prop({type: String, required: true}) private readonly icon!: string
    @Prop({type: String, default: undefined}) private readonly subIcon?: string
    @Prop({type: String, default: undefined}) private readonly subIconColor?: string
    @Prop({type: String, default: undefined}) private readonly subText?: string
    @Prop({type: String, default: undefined}) private readonly subTextColor?: string
    @Prop({type: String, default: undefined}) private readonly title?: string
    @Prop({type: String, default: undefined}) private readonly value?: string
    @Prop({type: String, default: undefined}) private readonly smallValue?: string
  }
